import {
  COMPARTMENTS_REQUEST,
  COMPARTMENTS_SUCCESS,
  COMPARTMENTS_ERROR,
  COMPARTMENTS_params,
  COMPARTMENTS_CLEAR,
  POSTCOMPARTMENTS_REQUEST,
  POSTCOMPARTMENTS_SUCCESS,
  POSTCOMPARTMENTS_ERROR,
  POSTCOMPARTMENTS_params,
  POSTCOMPARTMENTS_CLEAR,
} from '../actions/compartments';
import apiCalls from "utils/api";

const state = {
  compartments: [],
  compartmentsStatus: "",
  postcompartmentsStatus: "",
};

const getters = {
  getCompartments: state => state.compartments,
  isCompartmentsRequestSending: state => (state.compartmentsStatus == "loading" || state.postcompartmentsStatus == "loading"),
  getCompartmentsStatus: state => state.compartmentsStatus,
  getPostCompartmentsStatus: state => state.postcompartmentsStatus
};

const actions = {
  [COMPARTMENTS_REQUEST]: ({ commit, dispatch }, data) => {
    commit(COMPARTMENTS_REQUEST);
    apiCalls.apiCall({ url: "get", method: "GET", params: COMPARTMENTS_params })
      .then(resp => {
        commit(COMPARTMENTS_SUCCESS, resp.data);
      })
      .catch(() => {
        commit(COMPARTMENTS_ERROR);
      });
  },
  [POSTCOMPARTMENTS_REQUEST]: ({ commit, dispatch }, data) => {
    commit(POSTCOMPARTMENTS_REQUEST);
    apiCalls.apiCall2({ url: "post", method: "POST", data, params: POSTCOMPARTMENTS_params })
    .then(resp => {
      commit(POSTCOMPARTMENTS_SUCCESS);
    })
    .catch(() => {
      commit(POSTCOMPARTMENTS_ERROR);
    });
  }  
}

const mutations = {
  [COMPARTMENTS_REQUEST]: state => {
      state.compartmentsStatus = "loading";
  },
  [COMPARTMENTS_SUCCESS]: (state, resp) => {
      state.compartmentsStatus = "success";
      state.compartments = resp.data;
      Vue.set(state, "compartments", resp.data);
  },
  [COMPARTMENTS_ERROR]: state => {
      state.compartmentsStatus = "error";
  },
  [COMPARTMENTS_CLEAR]: state => {
      state.compartmentsStatus = "";
  },
  [POSTCOMPARTMENTS_SUCCESS]: (state, resp) => {
      state.postcompartmentsStatus = "success";
  },
  [POSTCOMPARTMENTS_ERROR]: state => {
      state.postcompartmentsStatus = "error";
  },
  [POSTCOMPARTMENTS_CLEAR]: state => {
      state.postcompartmentsStatus = "";
  }
};
export default {
    state,
    getters,
    actions,
    mutations
};